var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    {
      scopedSlots: _vm._u(
        [
          _vm.isEmbedded
            ? {
                key: "card-header",
                fn: function () {
                  return [
                    _c(
                      "b-button",
                      {
                        staticClass: "p-0",
                        attrs: { variant: "link" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("back")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n      ← " +
                            _vm._s(_vm.$t("global.words.back")) +
                            "\n    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "bold" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("financial-tools.maximumMortgage")) +
                          "\n    "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              }
            : null,
          {
            key: "card-footer",
            fn: function () {
              return [
                _c("mortgage-calculators-toolbar", {
                  attrs: { "is-loading": _vm.isLoading },
                  on: {
                    "clear-selection": _vm.handleClearSelection,
                    "run-report": _vm.runReport,
                    "set-default": _vm.handleCalc,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "12" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.MaxMordescription")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-1" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("financial-tools.income")) + "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-3",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "income",
                  placeholder: "0",
                  "class-name": "fe-num-field dollar",
                  "allow-minus": false,
                  label: _vm.$t("financial-tools.income").toString(),
                  "show-tooltip-message": true,
                  max: "9999999999.99",
                  "max-length": 14,
                  "error-message": _vm.erMsgs.errorMessageIncome.value,
                },
                model: {
                  value: _vm.indata.income,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "income", $$v)
                  },
                  expression: "indata.income",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", {
            staticClass: "align-items-center pt-2",
            attrs: { cols: "12", sm: "1" },
          }),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.property_taxes")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-3",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  "class-name": "fe-num-field dollar calculated",
                  "allow-minus": false,
                  label: _vm.$t("financial-tools.property_taxes").toString(),
                  max: "9999999999.99",
                  "max-length": 14,
                  "show-tooltip-message": true,
                  "error-message": _vm.erMsgs.errorMessagePropertytax.value,
                },
                model: {
                  value: _vm.indata.propertytax,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "propertytax", $$v)
                  },
                  expression: "indata.propertytax",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.interest_rate")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-3",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "interestRate",
                  "class-name": "fe-num-field decimal-input calculated",
                  decimals: 3,
                  "allow-minus": false,
                  label: _vm.$t("financial-tools.interest_rate").toString(),
                  "show-tooltip-message": true,
                  percentage: true,
                  max: "100",
                  "max-length": 6,
                  "error-message": _vm.erMsgs.errorMessageRate.value,
                },
                model: {
                  value: _vm.indata.interestRate,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "interestRate", $$v)
                  },
                  expression: "indata.interestRate",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", {
            staticClass: "align-items-center pt-2",
            attrs: { cols: "12", sm: "1" },
          }),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.heating_cost")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-3",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "heating_cost",
                  "class-name": "fe-num-field dollar",
                  "allow-minus": false,
                  label: _vm.$t("financial-tools.heating_cost").toString(),
                  "show-tooltip-message": true,
                  max: "9999999999.99",
                  "max-length": 14,
                  "error-message": _vm.erMsgs.errorMessageHeatingcost.value,
                },
                model: {
                  value: _vm.indata.heatingcost,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "heatingcost", $$v)
                  },
                  expression: "indata.heatingcost",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.monthly_debts")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-3",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "monthly_debts",
                  placeholder: "0",
                  "class-name": "fe-num-field dollar",
                  "allow-minus": false,
                  label: _vm.$t("financial-tools.monthly_debts").toString(),
                  "show-tooltip-message": true,
                  max: "9999999999.99",
                  "max-length": 14,
                  "error-message": _vm.erMsgs.errorMessageMonthlyDebts.value,
                },
                model: {
                  value: _vm.indata.monthlyDebts,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "monthlyDebts", $$v)
                  },
                  expression: "indata.monthlyDebts",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", {
            staticClass: "align-items-center pt-2",
            attrs: { cols: "12", sm: "1" },
          }),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.condo_fees")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-3",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "condofee",
                  placeholder: "0",
                  "class-name": "fe-num-field dollar calculated",
                  "allow-minus": false,
                  label: _vm.$t("financial-tools.condo_maintenance").toString(),
                  "show-tooltip-message": true,
                  max: "9999999999.99",
                  "max-length": 14,
                  "error-message": _vm.erMsgs.errorMessageCondofee.value,
                },
                model: {
                  value: _vm.indata.condofee,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "condofee", $$v)
                  },
                  expression: "indata.condofee",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("application-form.amortization")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-4",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("years-months-section", {
                attrs: {
                  name: "amortizPeriod",
                  placeholder: "0",
                  "class-name": "fe-num-field",
                  "allow-minus": false,
                  label: _vm.$t("application-form.amortization").toString(),
                  "show-tooltip-message": true,
                  disabled: _vm.indata.interestOnly,
                },
                model: {
                  value: _vm.indata.amortizPeriodMths,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "amortizPeriodMths", $$v)
                  },
                  expression: "indata.amortizPeriodMths",
                },
              }),
              _vm._v(" "),
              _c("section-error", {
                attrs: {
                  icon: false,
                  "error-message": _vm.erMsgs.errorMessageAmortizPeriod.value,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", {
            staticClass: "align-items-center pt-2",
            attrs: { cols: "12", sm: "1" },
          }),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.condoFeesPercentage")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-3",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "condofee",
                  placeholder: "0",
                  "class-name": "fe-num-field decimal-input calculated",
                  decimals: 3,
                  "allow-minus": false,
                  label: _vm
                    .$t("financial-tools.condoFeesPercentage")
                    .toString(),
                  "show-tooltip-message": true,
                  max: "999.99",
                  "max-length": 6,
                  "error-message": _vm.erMsgs.errorMessageIncCondo.value,
                },
                model: {
                  value: _vm.indata.condoFeesPercentage,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "condoFeesPercentage", $$v)
                  },
                  expression: "indata.condoFeesPercentage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.maximumGdsTds")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { "align-h": "end", cols: "12", sm: "1" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("application.calculations.gds")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "m-0 p-0 pb-3", attrs: { cols: "12", sm: "2" } },
            [
              _c("text-section", {
                attrs: {
                  name: "gds",
                  "class-name": "fe-num-field decimal-input calculated",
                  decimals: 3,
                  "allow-minus": false,
                  label: _vm.$t("application.calculations.gds").toString(),
                  "show-tooltip-message": true,
                  percentage: true,
                  max: "100",
                  "max-length": 6,
                  "error-message": _vm.erMsgs.errorMessageGDS.value,
                },
                model: {
                  value: _vm.indata.gds,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "gds", $$v)
                  },
                  expression: "indata.gds",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { "align-h": "end", cols: "12", sm: "1" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("application.calculations.tds")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "m-0 p-0 pb-3", attrs: { cols: "12", sm: "2" } },
            [
              _c("text-section", {
                attrs: {
                  name: "gds",
                  "class-name": "fe-num-field decimal-input calculated",
                  decimals: 3,
                  "allow-minus": false,
                  label: _vm.$t("application.calculations.tds").toString(),
                  "show-tooltip-message": true,
                  percentage: true,
                  max: "100",
                  "max-length": 6,
                  "error-message": _vm.erMsgs.errorMessageTDS.value,
                },
                model: {
                  value: _vm.indata.tds,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "tds", $$v)
                  },
                  expression: "indata.tds",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.prepared_for")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-1",
              attrs: { cols: "12", sm: "3" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "prepared_for",
                  "allow-minus": false,
                  label: _vm.$t("financial-tools.prepared_for").toString(),
                  "show-tooltip-message": true,
                  "max-length": 50,
                },
                model: {
                  value: _vm.indata.preparedFor,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "preparedFor", $$v)
                  },
                  expression: "indata.preparedFor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { "align-h": "end", cols: "12", sm: "2" },
            },
            [
              _c("checkbox-section", {
                attrs: {
                  label: _vm.$t("application-form.interest-only").toString(),
                  "show-tooltip-message": true,
                },
                model: {
                  value: _vm.indata.interestOnly,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "interestOnly", $$v)
                  },
                  expression: "indata.interestOnly",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-row", { staticClass: "m-3 mt-4" }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("financial-tools.summary")))]),
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-1 pb-3" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.maximumMortgage")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "align-items-center",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.formatMoney(_vm.outdata.maximumMortgage)) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("b-col", {
            staticClass: "align-items-center pt-2",
            attrs: { cols: "12", sm: "1" },
          }),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "align-items-center",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.totalMonthlyPayment")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "align-items-center",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.formatMoney(_vm.outdata.PandI)) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-row", { staticClass: "m-3" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("financial-tools.DHdisclaimer")) + "\n  "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }